import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../../assets/css/mobilefiltercss.css";
import FilterAllProductpdp from "../Filter/FilterAllProductpdp";

const EMPTY_FILTERS = {
  design: [],
  shade: [],
  size: [],
  shape: [],
  price: "",
};

const SidebarModal = ({
  position = "left",
  products = [],
  selectedFilters = EMPTY_FILTERS,
  onApplyFilters,
  onClearFilters,
}) => {
  const [show, setShow] = useState(false);

  const [tempFilters, setTempFilters] =
    useState(EMPTY_FILTERS);

  useEffect(() => {
    if (!show) {
      setTempFilters({
        design: selectedFilters?.design || [],
        shade: selectedFilters?.shade || [],
        size: selectedFilters?.size || [],
        shape: selectedFilters?.shape || [],
        price: selectedFilters?.price || "",
      });
    }
  }, [selectedFilters, show]);

  const handleOpen = () => {
    setTempFilters({
      design: selectedFilters?.design || [],
      shade: selectedFilters?.shade || [],
      size: selectedFilters?.size || [],
      shape: selectedFilters?.shape || [],
      price: selectedFilters?.price || "",
    });

    setShow(true);
  };

  const handleApply = () => {
    if (onApplyFilters) {
      onApplyFilters(tempFilters);
    }

    setShow(false);
  };

  const handleClear = () => {
    const emptyFilters = {
      ...EMPTY_FILTERS,
      design: [],
      shade: [],
      size: [],
      shape: [],
      price: "",
    };

    setTempFilters(emptyFilters);

    if (onClearFilters) {
      onClearFilters();
    }

    setShow(false);
  };

  return (
    <>
      <Link
        to="#"
        className="filter-border pdf-filter"
        onClick={(e) => {
          e.preventDefault();
          handleOpen();
        }}
      >
        Filter <i className="bi bi-sliders"></i>
      </Link>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName={`sidebar-modal ${
          position === "right"
            ? "right"
            : "left"
        }`}
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FilterAllProductpdp
            products={products}
            selectedFilters={tempFilters}
            setSelectedFilters={
              setTempFilters
            }
          />

          <div className="sidebar-footer mt-3 d-flex justify-content-between">
            <Button
              variant="outline-dark"
              onClick={handleClear}
            >
              Clear
            </Button>

            <Button
              variant="dark"
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SidebarModal;